import { Badge } from '@/components/ui/shadcn/badge';
import { useTranslations } from '@/hooks/useTranslations';

const statusBadgeClassMap: Record<string, string> = {
    new: 'bg-info-subtle text-info-subtle-foreground border-info-subtle-foreground/30',
    in_review: 'bg-cat-indigo text-cat-indigo-foreground border-cat-indigo-foreground/30',
    need_more_info: 'bg-warning-subtle text-warning-subtle-foreground border-warning-subtle-foreground/30',
    confirmed: 'bg-info-subtle text-info-subtle-foreground border-info-subtle-foreground/30',
    in_progress: 'bg-cat-purple text-cat-purple-foreground border-cat-purple-foreground/30',
    resolved: 'bg-success-subtle text-success-subtle-foreground border-success-subtle-foreground/30',
    duplicate: 'bg-cat-gray text-cat-gray-foreground border-cat-gray-foreground/30',
    rejected: 'bg-danger-subtle text-danger-subtle-foreground border-danger-subtle-foreground/30',
    archived: 'bg-cat-gray text-cat-gray-foreground border-cat-gray-foreground/30',
};

const severityBadgeClassMap: Record<string, string> = {
    low: 'bg-success-subtle text-success-subtle-foreground border-transparent',
    medium: 'bg-warning-subtle text-warning-subtle-foreground border-transparent',
    high: 'bg-warning-subtle text-warning-subtle-foreground border-transparent',
    critical: 'bg-danger-subtle text-danger-subtle-foreground border-transparent',
};

export function BugReportStatusBadge({ status }: { status: string }) {
    const { t } = useTranslations();

    return (
        <Badge variant="outline" className={statusBadgeClassMap[status] ?? ''}>
            {t(`bug_reports.status.${status}`, status)}
        </Badge>
    );
}

export function BugReportSeverityBadge({ severity }: { severity: string | null }) {
    const { t } = useTranslations();

    if (!severity) {
        return <span className="text-muted-foreground text-sm">—</span>;
    }

    return (
        <Badge variant="outline" className={severityBadgeClassMap[severity] ?? ''}>
            {t(`bug_reports.severity.${severity}`, severity)}
        </Badge>
    );
}
